export default __webpack_public_path__ + "static/media/toulouse-blagnac.e1185d3d.webp";